var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-header"},[_c('div',{staticClass:"mobile-header-text text-size-16 w-100",class:_vm.textColor},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.text)+" ")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }